<template>
  <v-card flat color="transparent">
    <v-container fluid class="pa-0 ma-0">
      <v-row no-gutters justify="end" align="center">
        <v-col cols="auto">
          <icon-button
            :icon="
              isSelected ? 'fas-circle-xmark' : 'ionic-md-information-circle'
            "
            :color="isSelected ? 'error' : 'primary'"
            @click="onClickInformacion"
          >
            {{
              $t(
                `reportes.tabla.boton-informacion.${
                  isSelected ? "cerrar" : "tooltip"
                }`
              )
            }}
          </icon-button>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script lang="ts">
// decoradores
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
// tipos
import { Item } from "@/typings/components/reportes/tabla";
import { Pesaje } from "@/typings/store/plugins/easyFirestore/pesajes";
// componentes
import IconButton from "@/components/custom/IconButton.vue";

@Component({
  components: {
    IconButton,
  },
})
export default class OpcionesTabla extends Vue {
  @Prop() readonly item!: Item;
  @Prop() readonly seleccionado!: Pesaje | null;

  get isSelected(): boolean {
    return (
      this.seleccionado !== null && this.seleccionado.id === this.item.pesaje.id
    );
  }

  @Emit("click:informacion")
  onClickInformacion(): Item {
    return this.item;
  }
}
</script>
